import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css/pagination";

import {
  PageOuter,
  PageWrapper,
  BackLink,
  HeroBlock,
  Badge,
  Title,
  Accent,
  SliderDynamicComponent,
  SliderImg,
  HeroImageWrap,
  HeroImage,
  ContentCard,
  LeadParagraph,
  MainText,
  VideoSection,
  VideoSectionTitle,
  VideoContainer,
  NotFoundBlock,
} from "./styled";

import { Container } from "../Container/Container";
import { useLocation } from "react-router-dom";
import { useNew } from "./hook/useNew";
import { useEffect } from "react";
import { Loader } from "../Loader/Loader";
import { routes } from "../../shared/routes/routes";

const getYouTubeVideoId = (url: string) => {
  const match = url.match(
    /(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/|watch\?.+&v=))([^?&]+)/
  );
  return match ? match[1] : null;
};

export const DynamicPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const location = useLocation();
  const { news, isLoading } = useNew({
    slug: location.pathname.split("/")[2],
  });

  if (isLoading) return <Loader />;

  if (!news?.title) {
    return (
      <Container>
        <PageOuter>
          <BackLink to={routes.onlyNews}>
            <svg viewBox="0 0 14 10" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13 5H1M1 5L5 1M1 5L5 9"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
              />
            </svg>
            Все новости
          </BackLink>
          <NotFoundBlock>Новость не найдена.</NotFoundBlock>
        </PageOuter>
      </Container>
    );
  }

  const otherImages = (news.otherImagesNews || []).filter(
    (img: any) => img && img.image
  );
  const hasGallery = otherImages.length > 0;

  const paragraphs: string[] = news.description || [];
  const [lead, ...rest] = paragraphs;

  const videos: string[] = (news.video || []).filter(Boolean);

  return (
    <Container>
      <PageOuter>
        <PageWrapper>
          <BackLink to={routes.onlyNews}>
            <svg viewBox="0 0 14 10" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13 5H1M1 5L5 1M1 5L5 9"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
              />
            </svg>
            Все новости
          </BackLink>

          <HeroBlock>
            <Badge>Новость</Badge>
            <Title>{news.title}</Title>
            <Accent />
          </HeroBlock>

          {hasGallery ? (
            <SliderDynamicComponent>
              <Swiper
                pagination={{ clickable: true }}
                modules={[Pagination, Autoplay]}
                autoplay={{ delay: 6000, disableOnInteraction: false }}
                loop
              >
                {otherImages.map((value: any, i: number) => (
                  <SwiperSlide key={i}>
                    <SliderImg src={value.image} alt={news.title} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </SliderDynamicComponent>
          ) : news.image ? (
            <HeroImageWrap>
              <HeroImage src={news.image} alt={news.title} />
            </HeroImageWrap>
          ) : null}

          {paragraphs.length > 0 && (
            <ContentCard>
              {lead && <LeadParagraph>{lead}</LeadParagraph>}
              {rest.map((value: string, idx: number) => (
                <MainText key={idx}>{value}</MainText>
              ))}
            </ContentCard>
          )}

          {videos.length > 0 && (
            <VideoSection>
              <VideoSectionTitle>Видео</VideoSectionTitle>
              <VideoContainer>
                {videos.map((url, index) => {
                  const videoId = getYouTubeVideoId(url);
                  if (!videoId) return null;
                  return (
                    <iframe
                      key={index}
                      src={`https://www.youtube.com/embed/${videoId}`}
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      title={`YouTube Video ${index + 1}`}
                    />
                  );
                })}
              </VideoContainer>
            </VideoSection>
          )}
        </PageWrapper>
      </PageOuter>
    </Container>
  );
};
